/**
 * テーマ名
 * 将来的に 'forest' | 'snow' | 'volcano' を追加予定
 */
export type ThemeName = "cave";

/**
 * テーマごとの色・装飾設定
 */
export interface ThemeConfig {
  name: ThemeName;
  /** フィールド背景色（CSS の --field-bg 変数に渡す hex string） */
  backgroundColor: string;
  floor: {
    base: number;
    variation: number;
    litByTorch: number;
    litCenter: number;
    gridLine: number;
    gridLineAlpha: number;
  };
  wall: {
    base: number;
    variation: number;
    gridLine: number;
    gridLineAlpha: number;
  };
  decorations: {
    torch: {
      /** 目標本数（マップサイズにより減る場合あり） */
      targetCount: number;
      /** たいまつ同士の最小マンハッタン距離 */
      minDistance: number;
      /** 炎の色（Phaser tween用） */
      flameColors: number[];
      /** 暖色ライティングの半径（マンハッタン距離） */
      lightRadius: number;
    };
    crystal: {
      /** 目標個数 */
      targetCount: number;
      /** 結晶の色（TODO: CSS変数経由で .gem の色に反映予定） */
      color: number;
      /** 結晶の発光色（TODO: CSS変数経由で .gem の glow に反映予定） */
      glowColor: number;
    };
  };
  vignette: {
    color: number;
    alpha: number;
  };
}

/**
 * 洞窟テーマ（案Gベース）
 */
const CAVE_THEME: ThemeConfig = {
  name: "cave",
  backgroundColor: "#3e3530",
  floor: {
    base: 0x6a5e50,
    variation: 0x5e5448,
    litByTorch: 0x75685a,
    litCenter: 0x806e5e,
    gridLine: 0x4a4038,
    gridLineAlpha: 0.3,
  },
  wall: {
    base: 0x4a4038,
    variation: 0x3a322a,
    gridLine: 0x2a2220,
    gridLineAlpha: 0.4,
  },
  decorations: {
    torch: {
      targetCount: 2,
      minDistance: 3,
      flameColors: [0xff8c00, 0xff6600, 0xffcc44],
      lightRadius: 2,
    },
    crystal: {
      targetCount: 40,
      color: 0xffbf00,
      glowColor: 0xffc840,
    },
  },
  vignette: {
    color: 0x000000,
    alpha: 0.18,
  },
};

const THEMES: Record<ThemeName, ThemeConfig> = {
  cave: CAVE_THEME,
};

/**
 * テーマ名から設定を取得
 */
export function getThemeConfig(name: ThemeName): ThemeConfig {
  return THEMES[name];
}
